// Mock data for The Vision Execution Company website

export const heroImages = {
  meditation1: 'https://images.unsplash.com/photo-1731461298531-9568f2351862',
  meditation2: 'https://images.unsplash.com/photo-1649029567910-dcbec9bb6396',
  calmWorkspace: 'https://images.unsplash.com/photo-1765648684898-2213d6b11c5d',
  modernOffice: 'https://images.pexels.com/photos/3727513/pexels-photo-3727513.jpeg',
};

export const growthImages = {
  workspace1: 'https://images.pexels.com/photos/6614838/pexels-photo-6614838.jpeg',
  workspace2: 'https://images.unsplash.com/photo-1739303987830-ca19742b19bc',
  professional1: 'https://images.unsplash.com/photo-1769071167147-97160f3f74e9',
  professional2: 'https://images.pexels.com/photos/3727513/pexels-photo-3727513.jpeg',
};

export const communityImages = {
  collaboration1: 'https://images.unsplash.com/photo-1739302750695-31a8c978c770',
  collaboration2: 'https://images.unsplash.com/photo-1739303987830-ca19742b19bc',
  workshop: 'https://images.unsplash.com/photo-1739298061740-5ed03045b280',
};

export const coreValues = [
  {
    id: 1,
    title: 'Human Before Hustle',
    description: 'You are a human being, not just a human doing. Your well-being comes first.',
    icon: 'Heart',
  },
  {
    id: 2,
    title: 'Systems with Soul',
    description: 'Structure and strategy that aligns with your values and vision.',
    icon: 'Compass',
  },
  {
    id: 3,
    title: 'Vision with Vitality',
    description: 'Growth that energizes you, not drains you.',
    icon: 'Sparkles',
  },
  {
    id: 4,
    title: 'Sacred Execution',
    description: 'We help you build with intention and execute with clarity.',
    icon: 'Target',
  },
];

export const productsAndServices = [
  {
    id: 'operational',
    name: 'Operational Infrastructure & Strategic Support',
    tagline: 'Strategic operational support that builds the systems, workflows, and infrastructure behind your business',
    description: 'Reliable operational infrastructure designed to keep your business organized and running smoothly behind the scenes. The Vision Execution Company supports CRM management, communication systems, workflow coordination, and administrative operations so your backend remains structured, efficient, and scalable—allowing you to focus on leadership, impact, and growth.',
    includes: [
      'Calendar & Schedule Management',
      'Email Management & Client Correspondence',
      'Workflow & Task Management',
      'Document Organization & System Setup',
      'Client Communication & Follow-Up',
      'Invoicing, Estimates & Administrative Coordination',
      'Additional operational support tailored to your business',
    ],
    accentColor: 'accent-green',
    flyerLink: '/flyers/operational-support',
    ctaText: 'Book an Operations Strategy Call',
    featured: true,
  },
  {
    id: 'launch',
    name: 'Launch Package',
    tagline: 'Complete launch strategy and business structure formation for entrepreneurs ready to bring their ideas to life',
    description: 'A comprehensive launch support package designed to help entrepreneurs move from vision to execution with clarity and structure. The Vision Execution Company guides you through the strategic foundation of your business, ensuring your operations, brand, and systems are organized for a successful and sustainable launch.',
    includes: [
      'Business Model Development',
      'Launch Strategy & Roadmap',
      'Business Structure Formation',
      'Brand Foundation Setup',
      'Initial Systems Implementation',
    ],
    accentColor: 'accent-blue',
    flyerLink: '/flyers/launch-package',
    ctaText: 'Book a Launch Strategy Call',
    featured: false,
  },
  {
    id: 'workshops',
    name: 'Workshops',
    tagline: 'Focused learning experiences designed to help entrepreneurs grow strategically and sustainably',
    description: 'Interactive workshops that combine practical business strategy with wellness-centered entrepreneurship. These sessions provide entrepreneurs with tools, frameworks, and guided exercises that support sustainable growth, clear vision, and aligned decision-making. Workshops may be offered privately, by request, or in partnership with business development organizations, municipalities, and entrepreneurial support programs.',
    includes: [
      'Vision & Goal Setting Workshops',
      'Systems & Process Design',
      'Wellness for Entrepreneurs',
      'Strategic Planning Sessions',
      'Custom Workshop Design',
    ],
    accentColor: 'accent-orange',
    flyerLink: '/flyers/workshops',
    ctaText: 'Request a Workshop',
    featured: false,
  },
  {
    id: 'ewc',
    name: 'The Entrepreneur Wellness Club',
    tagline: 'A wellness-centered membership community for entrepreneurs building sustainable businesses',
    description: 'The Entrepreneur Wellness Club is a supportive space designed for founders who want to grow their businesses without sacrificing their wellbeing. Members receive ongoing guidance, resources, and community support focused on balanced entrepreneurship, strategic thinking, and long-term sustainability.',
    includes: [
      'Monthly Alignment Workshops',
      'Community Co-Flow Sessions',
      'Digital Workbook Access',
      'Resource Library',
      'Private Community',
      'Guest Expert Sessions',
    ],
    accentColor: 'accent-purple',
    flyerLink: '/flyers/ewc-club',
    ctaText: 'Join the Wellness Club',
    featured: false,
  },
];

export const membershipBenefits = [
  {
    id: 'clarity',
    title: 'Clarity',
    description: 'Know exactly where you are going and why.',
    icon: 'Lightbulb',
  },
  {
    id: 'steadiness',
    title: 'Emotional Steadiness',
    description: 'Navigate challenges with calm and confidence.',
    icon: 'Shield',
  },
  {
    id: 'spaciousness',
    title: 'Spaciousness',
    description: 'Room to breathe, think, and create.',
    icon: 'CircleDot',
  },
];

export const membershipInclusions = [
  'Monthly Alignment Workshops',
  'Community Co-Flow Sessions',
  'Digital Wellness Hub Access',
  'Resource Library',
  'Private Community Access',
  'Guest Expert Sessions',
];

export const contactInfo = {
  email: 'hello@thevecllc.com',
  phone: '757-255-8491',
  tagline: "Let's create your custom growth blueprint",
  intakeForm: 'https://forms.gle/T1XryTU1b4NUd3gS7',
  calendly: 'https://calendly.com/hello-thevecllc/30min',
  socialMedia: {
    facebook: 'https://www.facebook.com/TheVisionExecutionCo',
    instagram: 'https://www.instagram.com/theve.co/',
    linkedin: 'https://www.linkedin.com/company/the-vision-execution-co/?viewAsMember=true',
  },
};
